<template>
  <div>
    <c-table-student-grade-transcript
      :title="title"
      :items="getItems"
      :columns="columns"
      :totalRows="totalRows"
      :perPage="perPage"
      :currentPage="currentPage"
      :api="api"
      :import="actions.import"
      :export="actions.export"
      @changeCurrentPage="changeCurrentPage"
      @changePerPage="changePerPage"
    ></c-table-student-grade-transcript>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdownItem,
  BDropdown,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import table from "@/libs/table";
import CTableStudentGradeTranscript from "@/components/CTableStudentGradeTranscript.vue";

export default {
  components: {
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    CTableStudentGradeTranscript,
  },
  data() {
    const permission = this.$store.getters["app/ACTIONS"];

    return {
      title: "Nilai Mahasiswa",
      api: "students",
      dir: false,
      items: [],
      totalRows: 0,
      perPage: 10,
      limit: 0,
      orderBy: "createdAt",
      sortBy: "desc",
      currentPage: 1,
      search: "",
      actions: {
        import: Boolean(permission.import),
        export: Boolean(permission.export),
      },
      exportFile: "list-mahasiswa.xlsx",
      columns: [
        { key: "no", label: "#", sortable: false },
        { key: "nim", label: "Nim", sortable: true },
        { key: "name", label: "Nama Mahasiswa", sortable: true },
        { key: "semester", label: "Semester", sortable: true },
        {
          key: "action",
          label: "aksi",
          class: "text-center",
          actions: {
            print: Boolean(permission.print),
          },
        },
      ],
    };
  },
  methods: {
    getItems(ctx, callback) {
      table.getItems(ctx, callback, this);
    },
    changeCurrentPage(page) {
      table.changeCurrentPage(this, page);
    },
    changePerPage(perPage) {
      table.changePerPage(this, perPage);
    },
  },
};
</script>
